import { createTheme } from "@mui/material/styles";

const getDesignTokens = (direction = "ltr") => ({
  direction,
  palette: {
    mode: "light",
    // Light mode with brand colors
    primary: {
      main: "#003E29", // Deep green
      light: "#4D786A", // Medium green
      dark: "#00281A", // Darker green (derived)
      contrastText: "#fff", // White for contrast
      background: "#f7f4ef",
      icons: "#7f7f7f",
    },
    secondary: {
      main: "#ffce02", // Bright yellow
      light: "#FFE066", // Light yellow (derived)
      dark: "#CC9F00", // Dark yellow (derived)
      contrastText: "#000", // Black for contrast (yellow is bright)
      input: "#ccc",
    },
    background: {
      default: "#F6F3EF", // Off-white background
      paper: "#FFFFFF", // Pure white for cards, etc.
      greyText: "#716a6aff",
      tabs: "#f7f4ef",
      lightGrey: "#F3F4F6", // Light grey for disabled fields
      veryLightGrey: "#F9FAFB", // Very light grey for hover states
    },
    text: {
      primary: "#003E29", // Deep green for primary text
      secondary: "#4D786A", // Medium green for secondary text
      subheading: "#aca9a7ff",
      main: "#103c22",
      greyed: "#8b8883",
      detail: "#656364",
      green: "#01402c",
      dark: "#1F2937", // Dark grey for headings
      medium: "#374151", // Medium grey for text
      light: "#6B7280", // Light grey for labels
      lighter: "#9CA3AF", // Lighter grey for secondary labels
    },
    success: {
      main: "#A2BD96", // Soft green for success states
      contrastText: "#003E29",
    },
    info: {
      main: "#A2BD96", // Reuse for info if needed
      labels: "#808080",
    },
    buttons: {
      main: "#a2bc95",
      badge: "#A2BD96",
      badgeInactive: "#F6F3EF",
      badgeText: "#003E29",
      add: "#4e786a",
      planned: "#f6f3ee",
      progress: "#d0ddcb",
      archive: "#efc6c4",
      addButton: "#fbf6f0",
      editButton: "#4f796b",
    },
    borders: {
      main: "#E5E7EB", // Main border color
      light: "#F3F4F6", // Light border color
      medium: "#D1D5DB", // Medium border color
    },
    bars: {
      main: "#a2bc95",
      secondary: "#4e786a",
      warning: "#ffd101",
    },
    downloader: {
      error: "#991B1B",
      errorBright: "#DC2626",
      border: "#D1D5DB",
      background: "#008060",
      paper: "#f0f0f0",
      bgPaper: "#cccccc",
    },
  },
  typography: {
    fontFamily: [
      "Rubik",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontSize: "2.5rem", fontWeight: 600, color: "#003E29" },
    h2: { fontSize: "2rem", fontWeight: 600, color: "#003E29" },
    h3: { fontSize: "1.75rem", fontWeight: 600, color: "#4D786A" },
    h4: { fontSize: "1.5rem", fontWeight: 500, color: "#003E29" },
    h5: { fontSize: "1.25rem", fontWeight: 500, color: "#4D786A" },
    h6: { fontSize: "1rem", fontWeight: 500, color: "#003E29" },
    button: { textTransform: "none", fontWeight: 500 },
    body1: { fontSize: "1rem", fontWeight: 400 },
    body2: { fontSize: "0.875rem", fontWeight: 400 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, padding: "8px 16px" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#003E29",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          h5: "h5",
          h6: "h6",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          width: "80%",
          display: "flex",
          justifySelf: "center",
        },
      },
    },
  },
});

export const createAppTheme = (direction = "ltr") => {
  return createTheme(getDesignTokens(direction));
};

export default createAppTheme;
